/* Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. */

import { Directive, TemplateRef } from '@angular/core';

@Directive({
	selector: '[customCheckboxContent]',
})
export class CustomCheckboxContentDirective {
	constructor(public templateRef: TemplateRef<unknown>) {}
}
